










































































import Vue, { PropType } from 'vue';
import { FirebaseID, FirestoreDate } from '@/modules/firestore';

type DataType = {
  currentPassword: string;
  newPassword: string;
}

export interface SubmitData {
  mailaddress: string;
  currentPassword: string;
  newPassword: string;
}

export interface AccountInfo {
  uid?: FirebaseID;
  registeredDate?: FirestoreDate | null;
  updatedDt?: FirestoreDate | null;
  phoneNumber?: string;
  email?: string;
}

export default Vue.extend({
  name: 'GAccountInfo',
  props: {
    accountInfo: {
      type: Object as PropType<AccountInfo>,
      required: true,
    },
  },
  computed: {
    mailaddress(): string {
      return this.$props.accountInfo.email || '';
    },
  },
  data(): DataType {
    return {
      currentPassword: '',
      newPassword: '',
    };
  },
  methods: {
    onSignOut() {
      this.$emit('signOut');
    },
    onChangePassword() {
      const values = {
        mailaddress: this.$props.accountInfo.emai,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      };
      this.$emit('changePassword', values);
    },
  },
});
